<div class="px-8 py-10 flex flex-col items-center text-center gap-6">

  <!-- Icon circle -->
  <div class="w-20 h-20 rounded-full flex items-center justify-center"
       [ngClass]="isConfirm ? 'bg-r50' : 'bg-b50'">
    <i class="ph text-4xl leading-none"
       [ngClass]="isConfirm ? 'ph-trash text-r300' : 'ph-info text-b300'"></i>
  </div>

  <!-- Heading + message -->
  <div class="space-y-2">
    <h4 class="text-base font-bold text-n900">{{ isConfirm ? 'Are you sure?' : 'Notice' }}</h4>
    <p class="text-sm text-n500 leading-relaxed" [innerHTML]="content"></p>
  </div>

  <!-- Action buttons -->
  <div class="flex gap-3 w-full">
    <button (click)="close()"
      class="flex-1 py-2.5 rounded-xl border border-n30 text-n500 text-sm font-medium hover:bg-n10 transition-colors">
      {{ labelNo }}
    </button>
    <button (click)="OkClick()"
      class="flex-1 py-2.5 rounded-xl text-white text-sm font-semibold transition-colors"
      [ngClass]="isConfirm ? 'bg-r300 hover:bg-red-700' : 'bg-b300 hover:bg-b400'">
      {{ labelOk }}
    </button>
  </div>

</div>
